import Toastr from "../../../itrust_common/components/Toastr"

// Show/update return InsuranceOrdersSerializer — lift orders_attributes for DetailForm
function normalizeOrder(raw = {}) {
  if (!raw.orders_attributes) return raw
  const nested = raw.orders_attributes
  return {
    ...nested,
    ...raw,
    id: raw.id,
    orders_insurance_id: raw.id,
    orders_order_id: raw.orders_order_id || nested.id,
    insurance_type: raw.insurance_type || nested.insurance_type,
    patient_attributes: nested.patient_attributes,
    store_attributes: nested.store_attributes,
    staff_attributes: nested.staff_attributes,
    available_receivable: nested.available_receivable,
    insurance_receivable: nested.insurance_receivable,
    check_postings: raw.check_postings || [],
    payments_attributes: raw.payments_attributes || [],
    payment_notes_attributes: raw.payment_notes_attributes || nested.payment_notes_attributes || [],
    procedures_attributes: nested.procedures_attributes || [],
    contact_lenses_attributes: nested.contact_lenses_attributes || [],
    misc_items_attributes: nested.misc_items_attributes || [],
    eyeglasses_attributes: nested.eyeglasses_attributes || [],
  }
}

function replaceInList(orders, updated) {
  const insuranceId = updated.orders_insurance_id || updated.id
  const index = orders.findIndex((item) => item.id === insuranceId || item.id === updated.id)
  if (index < 0) return orders

  const listItem = orders[index]
  const merged = (listItem.orders_attributes || updated.orders_attributes)
    ? {
        ...listItem,
        ...updated,
        id: listItem.id,
        orders_attributes: {
          ...listItem.orders_attributes,
          ...updated.orders_attributes,
          patient_attributes:
            updated.orders_attributes?.patient_attributes ||
            listItem.orders_attributes?.patient_attributes,
          insurance_receivable:
            updated.orders_attributes?.insurance_receivable ??
            updated.insurance_receivable ??
            listItem.orders_attributes?.insurance_receivable,
        },
        payments_attributes: updated.payments_attributes || listItem.payments_attributes || [],
      }
    : { ...listItem, ...updated }

  return [...orders.slice(0, index), merged, ...orders.slice(index + 1)]
}

const DEFAULT_STATE = {
  orders: [],
  order: {},
  versions: [],
  meta: { pagination: {} },
  saving: false,
  versionsLoading: false,
  editing: false,
}

export default function paymentReportReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'PAYMENT_REPORTS_LOAD_PENDING':
      return { ...state, saving: true }

    case 'VERSIONS_LOAD_PENDING':
      return { ...state, versionsLoading: true }

    case 'PAYMENT_REPORTS_LOAD_REJECTED':
    case 'PAYMENT_BULK_SENT_TO_TRIZZETO_REJECTED':
    case 'PAYMENT_REPORT_UPDATE_REJECTED':
    case 'PATIENT_STATEMENT_PRINT_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, saving: false }

    case 'VERSIONS_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, versionsLoading: false }

    case 'PAYMENT_REPORTS_LOAD_FULFILLED':
      return { ...state, ...response, saving: false }

    case 'PAYMENT_REPORT_LOAD_FULFILLED':
      return {
        ...state,
        order: normalizeOrder(response.order),
        saving: false,
      }

    case 'PAYMENT_REPORT_UPDATE_FULFILLED': {
      Toastr.handleShow(true, response.meta.message, 201)
      const updated = response.order
      return {
        ...state,
        orders: replaceInList(state.orders, updated),
        ...(action.meta?.keep_editing
          ? { order: normalizeOrder(updated), editing: state.editing }
          : { editing: false }),
        saving: false,
      }
    }

    case 'PAYMENT_REPORT_ORDER_LOAD':
      return {
        ...state,
        orders: replaceInList(state.orders, response.order),
        editing: false,
        saving: false,
      }

    case 'PAYMENT_REPORT_EDIT':
      return { ...state, editing: { ...action.payload }, order: {} }

    case 'PAYMENT_REPORT_EDIT_CANCEL':
      return { ...state, editing: false, order: {} }

    case 'PAYMENT_BULK_SENT_TO_TRIZZETO_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      return state

    case 'PAYMENT_REPORT_EXPORT_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      return { ...state, editing: false, saving: false }

    case 'VERSIONS_LOAD_FULFILLED':
      return {
        ...state,
        versions: response.versions || [],
        versionsLoading: false,
      }

    default:
      return state
  }
}
